import * as types from "./clipBoardTypes";

export const initState = {
  elementsCopyArray: null,
  styleClipboard: null
};

const ClipBoardReducers = (state = initState, action) => {
  switch (action.type) {
    // clear the clipboard
    case types.CLIP_BOARD_CLEAR: {
      return initState;
    }

    // add content to the clipboard
    case types.CLIP_BOARD_COPY: {
      return {
        ...state,
        elementsCopyArray: action.elementsCopyArray,
        sourceDesignSpecs: action.sourceDesignSpecs
      };
    }

    // copy style to style clipboard
    case types.CLIP_BOARD_COPY_STYLE: {
      return {
        ...state,
        styleClipboard: {
          styleData: action.styleData,
          sourceType: action.sourceType
        }
      };
    }

    // clear style clipboard
    case types.CLIP_BOARD_CLEAR_STYLE: {
      return {
        ...state,
        styleClipboard: null
      };
    }

    default:
      return state;
  }
};

export default ClipBoardReducers;
